import { SLUG_RULE, TITLE_RULE } from '@constants';

export const FORM_FIELD = {
  TITLE: {
    name: 'title',
    label: 'Title:',
    rules: [{ required: true, message: 'Title is required' }, TITLE_RULE],
  },
  SLUG: {
    name: 'slug',
    label: 'Slug:',
    rules: [{ required: true, message: 'Page slug is required' }, SLUG_RULE],
  },
  SEO_DESCRIPTION: {
    name: 'seoDescription',
    label: 'SEO description:',
    rules: [{ required: true, message: 'SEO description is required' }],
  },
  TEXT: {
    name: 'text',
    label: 'Text:',
    rules: [{ required: true, message: 'Body is required' }],
  },
  CHAPTERS: {
    name: 'chapters',
    label: 'Related chapters',
  },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);
